import styles from './Comparison.module.css'
import useReveal from '../hooks/useReveal.js'

const ROWS = [
  { label: 'Time to first shortlist', old: '2\u20133 weeks', new: '48 hours' },
  { label: 'How candidates are screened', old: 'Keyword search on a CV database', new: 'AI match across 40+ role signals' },
  { label: 'Who reviews the shortlist', old: 'Whoever\u2019s free that day', new: 'A recruiter who knows the role' },
  { label: 'Fee structure', old: 'Often 15\u201320% of salary, negotiated late', new: 'One flat fee, agreed before you commit' },
  { label: 'Coverage', old: 'Usually one city', new: 'Nationwide, remote-friendly' },
]

export default function Comparison() {
  const [ref, visible] = useReveal()

  return (
    <section className={styles.section} id="why-us">
      <div className="container">
        <div className={styles.header}>
          <h2 className={styles.heading}>Why teams switch to Virtual Recruiter</h2>
          <p className={styles.sub}>
            Same goal as any agency — the right person, in the role, quickly.
            Different method.
          </p>
        </div>

        <div ref={ref} className={`${styles.tableWrap} ${visible ? styles.visible : ''}`}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th scope="col" className={styles.rowHeadCol}></th>
                <th scope="col" className={styles.colOld}>Traditional agency</th>
                <th scope="col" className={styles.colNew}>Virtual Recruiter</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr key={row.label}>
                  <th scope="row" className={styles.rowHead}>{row.label}</th>
                  <td className={styles.cellOld}>{row.old}</td>
                  <td className={styles.cellNew}>{row.new}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}
